import { render } from "./FAQItem.vue?vue&type=template&id=0abf883f"
import script from "./FAQItem.vue?vue&type=script&lang=js"
export * from "./FAQItem.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./FAQItem.vue?vue&type=style&index=0&id=0abf883f&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__